import React, { ReactElement, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

import IconSelector from "components/shared/images/IconSelector";
import AppModal from "components/shared/modal/AppModal";

const ShowProxyInfo = (): ReactElement => {
 const intl = useIntl();

 const [open, setOpen] = useState<boolean>(false);

 const handleOpen = () => setOpen(true);
 const handleClose = () => setOpen(false);

 return (
  <>
   <Tooltip title={<FormattedMessage id="docker.proxy.proxyInfo" />}>
    <IconButton onClick={() => handleOpen()}>
     <IconSelector icon="InfoIcon" props={{ color: "info" }} />
    </IconButton>
   </Tooltip>
   <AppModal
    open={open}
    close={handleClose}
    title={intl.formatMessage({ id: "docker.proxy.proxyInfo" })}
    handleClose={handleClose}
    handleConfirm={handleClose}
    showConfirmButton={false}>
    <Typography>
     <FormattedMessage id="docker.proxy.explaining" values={{ br: <br /> }} />
    </Typography>
   </AppModal>
  </>
 );
};

export default ShowProxyInfo;
